var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reveal-route-direction-card" }, [
    _c(
      "div",
      {
        staticClass: "d-flex justify-content-between align-items-start mb-1",
        staticStyle: { gap: "8px" },
      },
      [
        _c("div", { staticClass: "mb-0" }, [
          _c("strong", [_vm._v(_vm._s(_vm.route.category))]),
        ]),
        _vm.showSelect && !_vm.selected
          ? _c(
              "button",
              {
                staticClass: "btn btn-sm btn-outline-primary flex-shrink-0",
                attrs: { type: "button", disabled: !_vm.selectable },
                on: {
                  click: function ($event) {
                    return _vm.$emit("select", _vm.route.route_id)
                  },
                },
              },
              [_vm._v(" Select ")]
            )
          : _vm.showSelect && _vm.selected
          ? _c(
              "button",
              {
                staticClass: "btn btn-sm btn-primary flex-shrink-0",
                attrs: { type: "button", disabled: "" },
              },
              [_vm._v(" Selected ")]
            )
          : _vm._e(),
      ]
    ),
    _vm.directionSummary
      ? _c("div", { staticClass: "small mb-1" }, [
          _vm._v(_vm._s(_vm.directionSummary)),
        ])
      : _vm._e(),
    _vm.embeddingText
      ? _c("div", { staticClass: "small text-muted mb-2" }, [
          _c("strong", [_vm._v("Embedding text:")]),
          _vm._v(" " + _vm._s(_vm.embeddingText) + " "),
        ])
      : _vm._e(),
    _vm.showTermsEditor && _vm.editRow
      ? _c(
          "div",
          { staticClass: "route-terms-edit-panel" },
          [
            _c("b-table", {
              staticClass: "mb-0",
              attrs: {
                items: _vm.routeRowEditFields,
                fields: [
                  { key: "type", label: "Type", thStyle: { width: "34%" } },
                  { key: "term", label: "Term" },
                ],
                small: "",
                striped: "",
                responsive: "sm",
                "head-variant": "light",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "cell(type)",
                    fn: function (row) {
                      return [_c("span", [_vm._v(_vm._s(row.item.type))])]
                    },
                  },
                  {
                    key: "cell(term)",
                    fn: function (row) {
                      return [
                        _c("input", {
                          staticClass: "form-control form-control-sm",
                          attrs: {
                            type: "text",
                            placeholder: "Comma-separated terms",
                            disabled: !_vm.termsEditable,
                          },
                          domProps: { value: _vm.editRow[row.item.key] },
                          on: {
                            input: function ($event) {
                              return _vm.$emit("update-route-edit-field", {
                                route: _vm.route,
                                fieldKey: row.item.key,
                                value: $event.target.value,
                              })
                            },
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                false,
                3465246729
              ),
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }